import React from "react";

// import ErrorIcon from "@common/assets/images/error.png";
// import { ReactComponent as WarningIcon } from "@common/assets/images/warning.svg";
import HorizontalBar from "@common/components/HorizontalBar/HorizontalBar";
import { NetworkHealthStatusDistribution } from "@common/models/Analytics.model";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { docLink } from "@common/util/docs";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { toHorizontalBarItems } from "@main/pages/Release/helpers/endpointStatusColors";
import * as Styled from "@main/pages/Release/views/MetricCards/EndpointsHealthCard.styles";
import { MetricCardEmptyState } from "@main/pages/Release/views/MetricCards/MetricCardEmptyState";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import { EndpointUrl } from "@main/pages/Release/views/MetricDetails/shared/EndpointUrl";

interface EndpointHealthCardProps extends ReleaseMetricCardBaseProps {
  data: EndpointHealthData[];
}

const EndpointHealthCard = ({ style, data, score, highlight, error, onMoreClick }: EndpointHealthCardProps) => {
  const isEmpty = data?.length === 0;

  const { selectedApp } = useAppSelectionContext();
  const platform = selectedApp?.platform?.name;

  return (
    <ReleaseMetricCard
      style={style}
      title={"Endpoints health"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      {!isEmpty ? (
        <Styled.EndpointList>
          {data.map((endpoint) => (
            <Styled.EndpointRow key={`${endpoint.method}-${endpoint.url}`}>
              <HorizontalBar
                style={{ width: "13rem" }}
                data={toHorizontalBarItems(endpoint.data, endpoint.isError)}
              />
              <div style={{ marginLeft: "1.6rem", marginRight: "0.8rem" }}>
                <Styled.MethodBadge>{endpoint.method}</Styled.MethodBadge>
              </div>
              <Flex
                style={{ minWidth: 0 }}
                $alignItems="center"
                $gap={0.4}
              >
                {/*{endpoint.isError ? (*/}
                {/*  <Styled.ErrorIconWrapper>*/}
                {/*    <img*/}
                {/*      src={ErrorIcon}*/}
                {/*      alt="error"*/}
                {/*    />*/}
                {/*  </Styled.ErrorIconWrapper>*/}
                {/*) : (*/}
                {/*  endpoint.isWarning && (*/}
                {/*    <Styled.WarningIconWrapper>*/}
                {/*      <WarningIcon />*/}
                {/*    </Styled.WarningIconWrapper>*/}
                {/*  )*/}
                {/*)}*/}
                <EndpointUrl
                  url={endpoint.url}
                  isError={endpoint.isError}
                  compact
                />
              </Flex>
            </Styled.EndpointRow>
          ))}
        </Styled.EndpointList>
      ) : (
        <MetricCardEmptyState
          text={"No network traffic recorded yet. If you haven't already, enable it in your SDK."}
          buttonText={"Enable network traffic"}
          onButtonClick={() => window.open(docLink(platform).networkTraffic, "_blank")?.focus()}
          column
        />
      )}
    </ReleaseMetricCard>
  );
};

export interface EndpointHealthData {
  url: string;
  method: string;
  data: NetworkHealthStatusDistribution[];
  isError?: boolean;
  isWarning?: boolean;
  score?: number | null;
}

export { EndpointHealthCard };
